import { render, staticRenderFns } from "./DialogSongs.vue?vue&type=template&id=5e55343f"
import script from "./DialogSongs.vue?vue&type=script&lang=js"
export * from "./DialogSongs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports